import { ProductType } from '@/types';
import { FEATURE_ORGANIC_ID } from './labelIds';

export function getIsOrganic(productType: ProductType) {
  return productType.labels?.features?.some((feature) => feature.id === FEATURE_ORGANIC_ID);
}
